module.exports = __webpack_public_path__ + "static/media/Lens-Accent Style_diameter.91b005de.png";